module.exports = __webpack_public_path__ + "static/media/Artboard13.2303a108.png";